"use client";

import { useAction, useQuery } from "convex/react";
import { toast } from "sonner";
import { api } from "@convex/_generated/api";
import {
  isSilentlyReleasable,
  type OpenCheckout,
} from "@/lib/checkout/open-checkout";

export const OPEN_CHECKOUT_MESSAGES = {
  underReview:
    "Your last payment is under review. Don't pay again.",
  processing:
    "Your last payment is still processing.",
} as const;

export function useOpenCheckoutRelease() {
  const openCheckout = useQuery(
    api.cart.checkoutAttemptQueries.getActiveCheckoutAttempt,
    {},
  );
  const release = useAction(api.cart.checkout.cancelOpenCheckoutAttempt);
  const clear = async (attempt: NonNullable<OpenCheckout>) => {
    if (attempt.paymentNeedsReview) {
      toast.info(OPEN_CHECKOUT_MESSAGES.underReview);
      return false;
    }
    if (!isSilentlyReleasable(attempt)) {
      toast.info(OPEN_CHECKOUT_MESSAGES.processing);
      return false;
    }
    const released = await release({ attemptId: attempt.attemptId });
    if (!released.paymentInFlight) return true;
    toast.info(OPEN_CHECKOUT_MESSAGES.processing);
    return false;
  };
  return {
    isLoading: openCheckout === undefined,
    releaseIfOpen: () => (openCheckout ? clear(openCheckout) : true),
  };
}
